/**
 * 判断当前路由是否由 ProjectAccessDeniedOverlay 接管无权限跳转。
 */
export function isProjectAccessOverlayRoute(pathname = window.location.pathname): boolean {
  return pathname.includes('/team_share') || pathname.includes('/team_studio');
}
